import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { WafCaptchaInterceptor } from 'Angular/services/core/waf-captcha.interceptor';
import { WAF_CAPTCHA_API_KEY, WafCaptchaService } from 'Angular/services/core/waf-captcha.service';
import { WafTokenInterceptor } from 'Angular/services/core/waf-token.interceptor';
import { SentryErrorHandler } from 'Angular/services/sentry/sentry.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
// This module sets the CSRF tokens. It must be imported into every app.module.ts!
export class ConfigModule {
}
ConfigModule.ɵfac = function ConfigModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfigModule)(); };
ConfigModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ConfigModule });
ConfigModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        {
            provide: ErrorHandler,
            useClass: SentryErrorHandler,
        },
        WafCaptchaService,
        {
            provide: WAF_CAPTCHA_API_KEY,
            useFactory: () => window.WAF_CAPTCHA_API_KEY ?? null,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WafCaptchaInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WafTokenInterceptor,
            multi: true,
        },
    ], imports: [HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'csrftoken',
            headerName: 'X-CSRFToken',
        })] });
